module.exports = __webpack_public_path__ + "img/xxlj_icon_3.1ec4f358.svg";